module.exports = __webpack_public_path__ + "static/Jumbo-07f0d1512dbd85263b5d571726c91330.jpg";